import { getLongDate, getShortDate, getWeek } from "utils/date.utils";

export interface activityType {
  sessionId?: string;
  type?: string;
  className?: string;
  title: string;
  imageSrc?: string;
  date?: string;
  longDate?: string;
  id: string;
  offline: boolean;
  status?: string;
  collecionId?: string;
  week?: {weekNumber: number, label: {firstDayWeek: string, lastDayWeek: string} };
  elements?: number;
  mandatory?: boolean;
  order?: number;
  sessionCreatedBy?: string;
  collectionName?: string;
  stageOrder?: number;
}
export interface ApiActivityType { 
  activity_id: string; 
  activity_session_id: string; 
  title: string; 
  thumbnail_image: string; 
  start_date: string; 
  end_date: string; 
  group_session_id: string;
  status: string;
  domains: string[]; 
  contains_external_element: boolean;
  result: string;
  owner_name: string | null;
}
/**
 * @class Defines an authentification object.
 */
export class ActivityModel {
    id: string;
    sessionId: string;
    type: string;
    title: string;
    imageSrc: string;
    rawDate: string;
    offline: boolean;
    status: string;
    sessionCreatedBy: string;
    
    /**
     * @constructor Creates an instance of an authentification object built from an original data from the API.
     * @param {bo} bo is the basic object come from API.
     */
    constructor(bo: ApiActivityType ) {
        this.id = bo.activity_id ;
        this.type = 'ACTIVITY';
        this.sessionId = bo.group_session_id;
        this.title = bo.title;
        this.imageSrc = bo.thumbnail_image;
        this.rawDate = bo.end_date;
        this.offline = false;
        this.status = bo.status;
        this.sessionCreatedBy = bo.owner_name ?? "";
    }

    get week() {
      return getWeek(this.rawDate);
    }
  
    get date() {
      return getShortDate(this.rawDate);
    }
    get longDate() {
      return getLongDate(this.rawDate);
    }
  
}
export interface ApiActivityFromCollectionType { 
    id: string; 
    type: string;
    title: string;
    thumbnail_image: string;
    collection_id: string;
    collection_name: string;
  } 
export class ActivityFromCollectionModel {
    id: string;
    type: string;
    title: string;
    imageSrc: string;
    offline: boolean;
    collecionId: string;
    collectionName: string;
    
    /**
     * @constructor Creates an instance of an authentification object built from an original data from the API.
     * @param {bo} bo is the basic object come from API.
     */
    constructor(bo: ApiActivityFromCollectionType) {
        this.id = bo.id;
        this.type = bo.type;
        this.title = bo.title;
        this.imageSrc = bo.thumbnail_image;
        this.offline = false;
        this.collecionId = bo.collection_id;
        this.collectionName = bo.collection_name;
    }
}

export interface CollectionType{
    id: string,
    name: string,
    resources: activityType[],
}
